import React, { useState, useEffect } from "react";
import '../../index.css';

const initialHouses = [
  { id: 1, name: "House 1", status: "Active" },
  { id: 2, name: "House 2", status: "Inactive" },

];

export default function House() {

  const STORAGE_KEY = "houses";
  const [HouseList, setHouseList] = useState([]);
  const [selectedHouse, setSelectedHouse] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    status: "Active"
  });

  // 🔍 FILTER
  const filteredHouses = HouseList.filter((s) =>
    s.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    s.status.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ADD
  const openAddModal = () => {
    setIsEdit(false);
    setFormData({
      id: "",
      name: "",
      status: "Active"
    });
    setShowModal(true);
  };

  // UPDATE
  const openEditModal = () => {
    if (!selectedHouse) {
      alert("Select a House first");
      return;
    }
    setIsEdit(true);
    setFormData(selectedHouse);
    setShowModal(true);
  };

  // DELETE
  const handleDelete = () => {
    if (!selectedHouse) return alert("Select a House first");

    const updated = HouseList.filter(
      (s) => s.id !== selectedHouse.id
    );

    setHouseList(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    window.dispatchEvent(new Event("storage"));

    setSelectedHouse(null);
  };

  // SAVE
  const handleSave = () => {
    if (!formData.name) return alert("All fields required");

    let updatedList = [];

    if (isEdit) {
      updatedList = HouseList.map((s) =>
        s.id === formData.id ? formData : s
      );
    } else {
      updatedList = [
        { ...formData, id: Date.now() },
        ...HouseList
      ];
    }

    setHouseList(updatedList);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedList));
    window.dispatchEvent(new Event("storage"));

    setShowModal(false);
    setSelectedHouse(null);
  };

  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

    if (saved.length === 0) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(initialHouses));
      setHouseList(initialHouses);
    } else {
      setHouseList(saved);
    }
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      setHouseList(saved);
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);



  return (
    <>
      <style>{`
        .page { background:#f5f7fb; padding:20px; }
        .card { background:#fff; padding:15px; border-radius:8px; }

        .header { display:flex; justify-content:space-between; margin-bottom:10px; }

        .controls { display:flex; gap:10px; margin-bottom:10px; flex-wrap:wrap; }

        .search-box {
          padding: 8px;
          border: 1px solid #ccc;
          border-radius: 4px;
        }

        .btn { padding:7px 12px; border:none; border-radius:4px; cursor:pointer; }
        .btn-dark { background:#2c3e50; color:white; }
        .btn-blue { background:#3498db; color:white; }
        .btn-red { background:#e74c3c; color:white; }

        table { width:100%; border-collapse:collapse; }
        th, td { padding:10px; border-bottom:1px solid #eee; }

        tr:hover { background:#f4f6f9; cursor:pointer; }
        .active-row { background:#eef3ff; }

        .status { color:green; }

        input[type="checkbox"] {
          cursor:pointer;
        }

        /* MODAL */
        .modal {
          position:fixed;
          top:0;
          left:0;
          width:100%;
          height:100%;
          background:rgba(0,0,0,0.5);
          display:flex;
          justify-content:center;
          align-items:center;
        }

        .modal-content {
          background:white;
          padding:20px;
          border-radius:8px;
          width:350px;
        }

        .modal-content input,
        .modal-content select {
          width:100%;
          margin-bottom:10px;
          padding:8px;
        }
      `}</style>

      <div className="page">
        <div className="card">

          {/* HEADER */}
          <div className="header">
            <h3>House</h3>
            <div>{HouseList.length} Records</div>
          </div>

          {/* CONTROLS */}
          <div className="controls">

            <input
              className="search-box"
              placeholder="Search House Name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <button className="btn btn-dark" onClick={openAddModal}>
              + Add House
            </button>

            <button className="btn btn-blue" onClick={openEditModal}>
              Update
            </button>

            <button className="btn btn-red" onClick={handleDelete}>
              Delete
            </button>
          </div>

          {/* TABLE */}
          <table>
            <thead>
              <tr>
                <th></th>
                <th>House Name</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {filteredHouses.map((s) => (
                <tr
                  key={s.id}
                  className={selectedHouse?.id === s.id ? "active-row" : ""}
                  onClick={() =>
                    setSelectedHouse(
                      selectedHouse?.id === s.id ? null : s
                    )
                  }
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selectedHouse?.id === s.id}
                      onChange={() =>
                        setSelectedHouse(
                          selectedHouse?.id === s.id ? null : s
                        )
                      }
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>

                  <td>{s.name}</td>
                  <td className="status">{s.status}</td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>

        {/* MODAL */}
        {showModal && (
          <div className="modal">
            <div className="modal-content">

              <h3>{isEdit ? "Update House" : "Add House"}</h3>

              <input
                placeholder="House Name"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />

              <select
                value={formData.status}
                onChange={(e) =>
                  setFormData({ ...formData, status: e.target.value })
                }
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>

              <div style={{ display: "flex", gap: "10px" }}>
                <button className="btn btn-blue" onClick={handleSave}>
                  Save
                </button>

                <button
                  className="btn btn-red"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
              </div>

            </div>
          </div>
        )}

      </div>
    </>
  );
}